import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { ConfirmPendingRegistrationData, ConfirmQuarantinedResponse, ConfirmRegisteredResponse, CreatePendingRegistrationData, PendingRegistrationResponse, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function pendingRegistration(config) {
    const confirmResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ parsers.taggedUnion('status', [
            ['registered', ConfirmRegisteredResponse],
            ['quarantined', ConfirmQuarantinedResponse],
        ]))),
    });
    const createResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(PendingRegistrationResponse)),
    });
    return Object.freeze({
        /**
         * Verify the email code and finalize the registration.
         *
         * The user provides the verification code along with their desired username, name, and (optionally) password. If the username is already taken, the code is not consumed and the user can retry.
         *
         * @param arg The arguments to the function.
         * @param arg.token The pending registration identifier.
         * @param arg.requestBody The body of the request.
         * @returns A login response or quarantine status.
         */
        confirm: async ({ token, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/registrations/pending/${token}/confirm`, confirmResponse.v, JSON.stringify(ConfirmPendingRegistrationData.encode(requestBody)));
            return result;
        },
        /**
         * Create a pending registration and send a verification code.
         *
         * Only an email address is required. The account details (username, name, password) are provided when confirming the registration.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns An identifier for the pending registration.
         */
        create: async ({ requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/registrations/pending`, createResponse.v, JSON.stringify(CreatePendingRegistrationData.encode(requestBody)));
            return result;
        },
    });
}
